/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./RoutedMessagesConfigSidePanel.vue?vue&type=template&id=1f7de6a8&scoped=true"
import script from "./RoutedMessagesConfigSidePanel.vue?vue&type=script&lang=js"
export * from "./RoutedMessagesConfigSidePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7de6a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f7de6a8')) {
      api.createRecord('1f7de6a8', component.options)
    } else {
      api.reload('1f7de6a8', component.options)
    }
    module.hot.accept("./RoutedMessagesConfigSidePanel.vue?vue&type=template&id=1f7de6a8&scoped=true", function () {
      api.rerender('1f7de6a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/routedMessages/RoutedMessagesConfigSidePanel.vue"
export default component.exports